import { NSARouterMakerResult, NSAHomePage } from 'namirasoft-account-react';
import { MessageLayout } from '../MessageLayout';
import { MessageRouterProps } from '../MessageRouterProps';

interface HomePageProps extends NSARouterMakerResult, MessageRouterProps
{ }

export default function HomePage(props: HomePageProps)
{
    return (
        <MessageLayout
            {...props}
        >
            <NSAHomePage
                {...props}
            />
        </MessageLayout>
    );
}